import { ScreenSize } from 'glints-aries/lib/Utils/StyleConfig';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  img {
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    box-sizing: border-box;
  }
`;

export const GallerySection = styled.div`
  margin-top: 10px;
  width: 100%;

  .gallery-wrapper {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 8px;
  }

  .gallery-item {
    width: 100%;
    margin: 0;

    > div {
      aspect-ratio: 1 / 1;
      overflow: hidden;
      width: 100%;
      > div {
        height: 100%;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  @media (max-width: ${ScreenSize.mobileL}px) {
    width: 100%;

    .gallery-wrapper {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
      width: 100%;
      box-sizing: border-box;
    }

    .gallery-item {
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
      margin: 0;
    }
  }
`;

export const CustomGalleryImageWrapper = styled.div`
  padding: 0;
  position: relative;
`;
